import request from './request'
import api_config from '../../server_config/http'
import Vrouter from '@/router'


let $http: any = {
    code: api_config.code,
    bserUrl: api_config.bserUrl,
    special_url: api_config.special_url,
    javaApiUrl: api_config.javaApiUrl,
    KjavaApiUrl: api_config.KjavaApiUrl,
    expressApiUrl: api_config.expressApiUrl,
    afterSaleUrl: api_config.afterSaleUrl,
    afterChatUrl: api_config.afterChatUrl,
    subJavaUrl: api_config.subJavaUrl,
    liteDevUrl: api_config.liteUrl,
    searchUrl: api_config.searchUrl,
    sa: {},//埋点
    sa_obj: {},
    token: '',    // 认证信息
    kong_token: '',    // 认证信息
    headers: {
        Accept: 'application/json',
        'Authorization': ''
    },
    su: null,
    no_webp: document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') < 0,
    // 站点信息
    site(para: object) { return this.get('v1/site', para) },
    // 分类信息
    get_category_tree() { return this.get('v1/front-categories/children', {}) },
    //筛选数据测试
    filtrateData(para: object) {
        return this.get('v1/product/search', para)
    },

    /** 秒杀接口 */
    get_flashsales(para: object) { return this.get('v1/flashsales', para) },

    /** 下单数据获取 */
    post_buy_data(para: Object) { return this.post('v1/user/buyData', para, true) },
    /** 使用voucher code */
    post_vouchercode_check(para: object) { return this.post('v1/user/voucherCode/check', para, true) },
    /** 提交下单数据 */
    post_checkOut_order(para: Object) { return this.post('v1/user/checkOutOrder', para, true) },
    /** 收银台支付 */
    get_pay(para: object) { return this.post('v1/user/pay', para, true, true) },
    /** 查询支付状态 */
    get_pay_result(para: object) { return this.get('v1/user/payResult', para, true) },
    // 获取订单需要支付的剩下的实际金额
    get_left_payInfo(para: any) { return this.get('v1/user/payInfo', para, true) },

    /** 获取首页JSON */
    get_special_home(para: object) { return this.get_special('/special_json/wap_home.json', para) },


    /**热门分类 */
    get_hotcategory(para: object) { return this.get('v1/product/hotcategory', para) },
    //商品推荐
    recommend(para: object) { return this.get('v1/product/recommend', para) },

    // 验证码
    captcha(para: object) { return this.post('v1/user/captcha', para, false, true) },

    register(para: object) { return this.post('v1/user/register', para, false, true) },
    login(para: object) { return this.post('v1/user/login', para, false, true) },
    checkCaptcha(para: object) { return this.post('v1/user/checkCaptcha', para, false, true) },
    findPassword(para: object) { return this.post('v1/user/findPassword', para, false, true) },//找回密码
    profile(para: object) { return this.get('v1/user/profile', para, true, true) },
    setting(para: object) { return this.post('v1/user/setting', para, true) },
    password(para: object) { return this.post('v1/user/password', para, true, true) },
    bind(para: object) { return this.post('v1/user/bind', para, true, true) },
    // 刷新token
    oauthToken(para: object) { return this.post('v1/fresh_token', para, false, false, false, false) },
    //地址推荐列表
    post_address(para: object) { return this.post('v1/user/address', para, true) },
    post_areas(para: any) { return this.get('v1/address/areas?size=100&parent_id=' + para.parent_id, para) },
    delete_address(para: any) { return this.post('v1/user/address/' + para.id, para, true) },
    post_stations(para: any) { return this.get('v1/address/stations?area_id=' + para.area_id, para) },
    update_address(para: any) { return this.post('v1/user/address/address_id=' + para.id, para, true) },
    // 浏览历史记录
    get_browse_history(para: any) { return this.get('v1/user/browse', para, true) },
    delete_browse_history(para: any) { return this.post('v1/user/browse/' + para.id, para, true) },
    // 商品收藏
    get_favorite_list(para: any) { return this.get('v1/user/favoriteGoods', para, true) },
    delete_favorite_goods(para: any) { return this.post('v1/user/favorite/action', para, true) },
    // 店铺收藏
    get_store_favorite_list(para: any) { return this.get('v1/user/favoriteStore', para, true) },
    // 积分详情 
    get_coins_list(para: any) { return this.get('v1/user/asset/logs', para, true) },
    // 我的优惠券
    get_voucher_list(para: any) { return this.get('v1/user/voucher', para, true) },
    // 找回密码
    modifyPassword(para: any) { return this.post('v1/user/password', para, true, true) },
    /** 获取用户积分 */
    post_Feedbacks_Cash_Rewards(para: any) { return this.get('v1/user/asset/balance', para, true) },
    /**
    
     /**
      * 
      * 个人中心模块
     */
    //电话邮箱修改
    personal_data(para: any) { return this.post('v1/user/setting', para, true) },
    //修改头像
    portrait_editor(para: any) { return this.post('v1/user/avatar', para, true, true, true, true) },
    //广告
    get_advertisement(para: Object) { return this.get('v1/advertisement', para) },


    /** 商品模块 **/
    get_hotSearch(para: Object) { return this.get('v1/product/hotSearch', para) }, //商品搜索排行榜
    get_word_auto_complete(para: Object) { return this.get('v1/wordAutoComplete', para) }, //商品检测关键词
    search(para: any, token: any) { return this.get('v1/product/search', para, token, false, true, undefined, false) },//商品搜索

    /** 店铺模块  **/
    //店铺资料
    get_shop_info(para: any) { return this.get('v1/store/' + para.id, para, false) },
    //店铺首页
    get_shop_index(para: any) { return this.get('v1/store/index/' + para.id, para) },
    //增加或者取消店铺收藏，参数action=insert(增加)action=remove(取消）
    add_or_cancel_favoriteStore(para: Object) { return this.post('v1/user/favorite/action', para, true) },
    //店铺优惠券
    get_shop_voucher(para: any) { return this.get('v1/store/voucher/' + para.id, para, false) },
    //领劵
    receiveVoucher(para: any) { return this.post('v1/user/receiveVoucher', para, true, true) },


    /** 钱包接口 */
    get_walletInfo(para: Object) { return this.get('v1/user/walletInfo', para, true) },
    get_walletPage(para: Object) { return this.get('v1/user/walletPage', para, true) },
    // 购物车
    cart(para: any) { return this.get('v1/user/cart', para, true) },
    cart_create(para: any) { return this.post('v1/user/cart/create', para, true, true) }, // 添加购物车
    cart_update(para: any) { return this.post('v1/user/cart/update', para, true) }, // 编辑购物车
    cart_delete(para: any) { return this.post('v1/user/cart/delete', para, true) }, // 删除购物车
    insert_favoriteGoods(para: any) { return this.post('v1/user/favorite/action/', para, true, true) },//增加商品收藏
    /** 订单模块 */
    orders(para: any) { return this.get('v1/user/orders', para, true) },
    order_info(para: any) { return this.get('v1/user/orderInfo', para, true) },
    order_change_state(para: any) { return this.post('v1/user/orderChangeState', para, true, true) },
    logistics_info(para: any) { return this.get('v1/user/logisticsInfo', para, true) },
    /**
     
      /** 商品详情 **/
    detail(para: any, token: any) { return this.get('v1/product/detail/' + para.id, para, token, true) },//商品详情 
    /** 商品评价 */
    commentList(para: any) { return this.get('v1/product/comment/list', para, false) },

    // 到货通知
    get_notify(para: any) { return this.post('v1/user/getGoodsCustomizeInfo', para, true) },//到货通知的状态
    add_or_cancel_notify(para: any) { return this.post('v1/user/subscribeGoods', para, true, true) },//增加或者取消到货通知

    /** 文章模块 */
    get_article_class(para: any) { return this.get('v1/content/categories', para) },
    get_article_list(para: any) { return this.get('v1/content/articles', para) },
    get_article_detail(para: any) { return this.get('v1/content/articles/' + para.id, {}, false, false, true, undefined, false) },



    // 获取运单号
    getTrackCode(para: any) { return this.get('v1/ke/getTrackCode?', para, false, false, false,) },
    // 物流轨迹
    getLogistics(params: any) { return this.get('/tracking/getTrackingInfos/' + 'v3' + '/' + params.bizOrderNo + '?langType=' + params.langType + '&identity=' + params.identity, null, false, false, false, this.expressApiUrl) },
     // 物流轨迹
    getLiteLogistics(params: any, code: string) { return this.get('/tracking/getTrackingInfos/' + 'v3' + '/' + params.bizOrderNo + '?langType=' + params.langType + '&identity=' + params.identity, null, false, false, false, code === 'test' ? 'https://express-gw.kilitest.com' : 'https://gw.kiliexpress.com') },
    // 网点信息
    getPickupInfo(params: any) { return this.get('/network/network/business/base?stationId=' + params, null, false, false, false, this.expressApiUrl) },
    // 网点信息
    getLitePickupInfo(params: any, code: string) { return this.get('/network/network/business/base?stationId=' + params, null, false, false, false,  code === 'test' ? 'https://express-gw.kilitest.com' : 'https://gw.kiliexpress.com') },

    // 砍价接口
    get_nologin_post(params: any) { return this.post('activity/v1/ke/nologin_post', params, false, false, true, false) },

    // 完成大转盘任务
    postAchieveTaskNotice(params: any) { return this.post('/luckydraw/v1/user/achieveTaskNotice', params, true,false,false,false, params.is_k ? this.KjavaApiUrl : this.javaApiUrl ) },
    
    // 参与大转盘抽奖
    postLuckyDraw(params: any) { return this.post('/luckydraw/v1/user/luckyDraw', params, true,false,false,false, params.is_k ? this.KjavaApiUrl : this.javaApiUrl  ) },

    // 获取用户中奖记录
    getluckyDrawHistoryRecord(params: any) { return this.get('/luckydraw/v1/user/luckyDrawHistoryRecord?lotteryId=' + params.lotteryId + '&pageSize=20&pageIndex=' + params.page, {}, true,false,false, params.is_k ? this.KjavaApiUrl : this.javaApiUrl  ) },

    // 获取抽奖次数和任务状态
    getLuckyDrawUserNumber(params: any) { return this.get('/luckydraw/v1/user/luckyDrawUserNumber', params, true,false,false, params.is_k ? this.KjavaApiUrl : this.javaApiUrl  ) },

    // 获取banner
    getLuckyDrawBannerByLottery(params: any) { return this.get('/luckydraw/v1/open/luckyDrawBannerByLottery', params, false,false,false,this.KjavaApiUrl ) },

    // 获取单个转盘活动中奖记录
    getLuckyDrawRecordByLottery(params: any) { return this.get('/luckydraw/v1/open/luckyDrawRecordByLottery', params, false,false,false,this.KjavaApiUrl ) },

    // 转盘评论后更新状态
    getUpdateLuckyDrawCommentRecord(params: any) { return this.get('/luckydraw/v1/user/updateLuckyDrawCommentRecord?lotteryId=' + params.lotteryId + '&recordId=' + params.record_id, {}, true,false,false, params.is_k ? this.KjavaApiUrl : this.javaApiUrl  ) },

    // 获取奖项数据
    getActGoodsById(params: any) { return this.get('/manager/api/actBase/detail', params, false, false, false, this.javaApiUrl) },

    // 获取转盘任务列表
    getTaskList(params: any) { return this.get('/manager/api/luckDraw/getTaskList', params, false,false,false,this.javaApiUrl ) },

    // 获取评价列表
    getAllComment(params: any) { return this.post('/globalComment/comment/getAllCommentForApp', params, false,false,false,false,this.subJavaUrl ) },


    //搜索列表物流类型
    serachLogistics(params: any) { return this.get('v1/logistic-desc') },

    //订阅退订接口
    subscription(params: any) { return this.post('/nmdc/v1/user/subscribe', params, false, false, false, false, this.subJavaUrl) },





    /**逛逛分享视频图文模块 */
    //逛逛分享页详情
    getSafariSareDetails(params: any) { return this.get('apisafari/v1/open/query/details?contentsId=' + params.id, null, false, false, false, params.is_k ? this.KjavaApiUrl : this.javaApiUrl) },
    //逛逛分享页推荐列表
    getSafariSareList(params: any) { return this.get('/apisafari/v1/open/query/top4SafariList', null, false, false, false, params.is_k ? this.KjavaApiUrl : this.javaApiUrl) },


    /**售后模块 */
    // 新的上传文件第一步---文件检查并返回上传url及密钥
    updateFileInspect(params: any) { return this.post('/upload-file-service', params, true, false, false, false, this.liteDevUrl) },
    // 上传文件 视频图片文件都支持
    // updateFile(params: any) { return this.post('/file/fileUpload/v1.0/simpleFile', params, true, false, false, false, params.is_k ? this.KjavaApiUrl : this.javaApiUrl) },
    /** 可售后列表 */
    getAfterSalePreorderList(params: any) { return this.get(`/aftersale/v1/${this.code}/buyer/preorder`, params, false, false, false, this.afterSaleUrl, true, true) },
    // 售后原因列表
    getAfterSaleReasonList(params: any) { return this.get(`/aftersale/v1/${this.code}/open/reasons`, params, false, false, false, this.afterSaleUrl, true, true) },
    // 售后规则
    getAfterSaleRule(params: any) { return this.get(`/aftersale/v1/${this.code}/open/rule`, params, false, false, false, this.afterSaleUrl, true, true) },
    /** 售后类型 */
    getAfterSaleTypeList(params: any) { return this.get(`/aftersale/v1/${this.code}/buyer/supportService`, params, false, false, false, this.afterSaleUrl, true, true) },
    // 提交售后申请
    setAfterSale(params: any) { return this.post(`/aftersale/v1/${this.code}/buyer/applyService`, params, false, false, false, false, params.is_k ? this.KjavaApiUrl : this.afterSaleUrl, true) },
    // 正在售后中列表
    getAfterSaleList(params: any) { return this.get(`/aftersale/v1/${this.code}/buyer/orderList`, params, false, false, false, this.afterSaleUrl, true, true) },
    // 获取商家地址
    getBusinessAddress(params: any) { return this.get(`/aftersale/v1/${this.code}/buyer/getAddress`, params, false, false, false, this.afterSaleUrl, true, true) },
    // 售后单操作（发货方式/申诉等需要操作售后单的）
    setAfterSaleExpressWay(params: any) { return this.post(`/aftersale/v1/${this.code}/buyer/checkService`, params, true, false, false, false, params.is_k ? this.KjavaApiUrl : this.afterSaleUrl, true) },
    // 售后详情
    getAfterSaleDetail(params: any) { return this.get(`/aftersale/v1/${this.code}/buyer/orderDetail`, params, false, false, false, this.afterSaleUrl, true, true) },
    // 售后评价
    setAfterComment(params: any, afterId: any) { return this.post(`/aftersale/v1/${this.code}/buyer/addComment/${afterId}`, params, false, false, false, false, params.is_k ? this.KjavaApiUrl : this.afterSaleUrl, true) },
    // 售后联系商家客服
    getChatRoom(params: any) { return this.post(`/user/v1/buyer/${this.code}/chat/getChatRoom`, params, false, false, false, false, params.is_k ? this.KjavaApiUrl : this.afterChatUrl, true) },
    // 评论服务--新增评论
    setComment(params: any) { return this.post(`/globalComment/comment/addComment`, params, true, false, false, false, params.is_k ? this.KjavaApiUrl : this.subJavaUrl, false) },
    // 满减包邮
    getPostage(params: any) { return this.get(`/apigoods/v1/${this.code}/common/product/postage`, params, false, false, false) },
    // 代付
    getReplace(params: any) { return this.get(`/${this.code}/v1/payment/replace?pay_sn=`+ params, null, false, false, false) },
    // 注销账号查询
    getAccountStateKili(Token: any) { return this.get('/buyer/v1/ke/account-state', null, false, false, false, api_config.bserUrl, false, false, Token)},
    // 申请注销账号 buyer/v1/ke/account-cancellation-application
    accountApplication(params: any, Token: any) { return this.post('buyer/v1/ke/account-cancellation-application', params, false, false, false, false, api_config.bserUrl, false, Token)},
    // buyer/v1/ke/cancel-account-cancellation
    cancelAccountApplication(Token: any) { return this.post('buyer/v1/ke/cancel-account-cancellation', null, false, false, false, false, api_config.bserUrl, false, Token)},
    // lite 注销账号查询
    getAccountStateLite(Token: any) { return this.get('/account-cancellation-state', null, false, false, false, this.liteDevUrl, false, false, Token) },
    accountApplicationLite(params:any, Token: any) { return this.post('/account-cancellation-application', params, false, false, false, false, this.liteDevUrl, false, Token) },
    cancelAccountApplicationLite(Token: any) { return this.post('/cancel-account-cancellation-application', null, false, false, false, false, this.liteDevUrl, false, Token) },

    // 领取优惠券
    postVoucher(params: any) { return this.post(`/index.php?act=member_voucher&op=voucher_exchange&vid=${params.vid}&is_seller=0`, null, true, false, false, false, api_config.mobilePhpUrl)},

    /** 搜索服务 - start */
    searchV2(params: ISearchV2Params) {
        return this.post(`/apisearch/v1/open/${this.code}/search`, params, false, false, false, false, this.searchUrl)
    },
    /** 搜索服务 - end */

    /**
   * 设置 code
   * @param {*} code
   */
    setCode(code: string): object {
        this.code = code
        return this
    },
    /**
     * 设置 Token
     * @param {*} token
     */
    setToken(token: string): object {
      console.log(token, '---token--')
        this.token = token
        return this
    },
     /**
     * 设置 KongToken
     * @param {*} token
     */
    setKongToken(token: string): object {
        this.kong_token = token
        return this
    },
    /**
     * 清除token
     */
    clearToken(): void {
        this.token = ''
        this.kong_token = ''
    },
    /**
     * Get 请求专题页
     * @param url 
     * @param params 
     * @param auth 
     * @param sa 
     * @param form_date 
     */
    async get_special(url: string, params: object): Promise<any> {

        return request({
            baseURL: this.special_url,
            url: url,
            method: 'get',
            params: params
        }).then(ret => {
            return ret
        })
            .catch(error => { return error })

    },
    get_sa(sa: any) {
        this.sa = sa
    },
    set_sa_obj($sa: any) {
        this.sa_obj = $sa
    },
    get_sa_obj() {
        return this.sa_obj
    },

    /**
     * Get 请求
     * @param url 
     * @param params 
     * @param auth 
     * @param sa 
     * @param form_date 
     */

    async get(url: string, params: object, auth = false, sa = false, is_code = true, ApiUrl = api_config.bserUrl, is_client = true, kongAuth = false, headers = null): Promise<any> {
        
        if (auth) this.auth()
        if (kongAuth) this.kongAuth()
        if (sa) Object.assign(this.headers, this.sa)
        if (this.no_webp) Object.assign(this.headers, { 'NOWEBP': 1 })
        if (is_client) {
            Object.assign(this.headers, { 'client': 'wap' })
        } else {
            this?.headers?.client && (delete this.headers.client)
        }
        // 判断是api接口强制添加sa头参数
        if(ApiUrl === api_config.bserUrl && this.sa) {
            Object.assign(this.headers, this.sa)
        }
        return request({
            baseURL: ApiUrl,
            url: is_code ? this.url(url) : url,
            method: 'get',
            params: params,
            headers: headers || this.headers
        }).then(ret => {
            return ret
        })
            .catch(error => { return error })
    },
    /**
     * Post 请求
     * @param url 
     * @param params 
     * @param auth 
     * @param sa 
     * @param form_date 
     */

    async post(url: string, params: object, auth = false, sa = false, form_date = false, is_code = true, ApiUrl = api_config.bserUrl, kongAuth = false, headers = null): Promise<any> {
        console.log('form_date', auth, kongAuth);

        if (auth) this.auth()
        if (kongAuth) this.kongAuth()
        if (sa) Object.assign(this.headers, this.sa)
        if (this.no_webp) Object.assign(this.headers, { 'NOWEBP': 1 })
        if (form_date) Object.assign(this.headers, { 'Content-Type': 'multipart/form-data' })
        Object.assign(this.headers, { 'client': 'wap' })
        // 判断是api接口强制添加sa头参数
        if(ApiUrl === api_config.bserUrl && this.sa) {
            Object.assign(this.headers, this.sa)
        }
        return request({
            baseURL: ApiUrl,
            url: is_code ? this.url(url) : url,
            method: 'post',
            data: params,
            headers: headers || this.headers
        }).then(ret => {
            return ret
        })
            .catch(error => {
                if (error.code === 401) this.expired();
                return error;
            })
    },
    /**
     * 鉴权失败处理
     */
    expired() {
        // 没有token处理逻辑
        // common.delStorage('redirect_url')
        // console.log('redirect_ur232323l')
        // let str = null
        //   if(window.location.pathname.includes('/new')) {
        //     str = window.location.pathname.replace("/new","")
        //   } else {
        //     str = window.location.pathname
        //   }
        //   common.setStorage('redirect_url', str + window.location.search)
        const router: any = Vrouter;
        router.push('/login')


    },
    /**
     * token获取
     */
    auth() {
        if (this.token === '' || !this.token || this.token == 'null') {
            this.token = String(common.getStorage('access_token'));
            if (this.token === '' || !this.token || this.token == 'null') this.expired()
            // return false
        }
        this.headers.Authorization = 'Bearer ' + this.token
    },
    /**
     * kong_access_token获取
     */
    kongAuth() {
        if (this.kong_token === '' || !this.kong_token || this.kong_token == 'null') {
            this.kong_token = String(common.getStorage('kong_access_token'));
            if (this.kong_token === '' || !this.kong_token || this.kong_token == 'null') this.expired()
            // return false
        }
        this.headers.Authorization = 'Bearer ' + this.kong_token
        // this.headers.Authorization = 'Bearer MWAm95sPP146ZnPD7toJa6ChXE50lMGm' 
    },
    /**
     * 接口请求增加站点
     * @param url 
     */
    url(url: string) {
        return this.code + '/' + url
    }

}
export default $http